<template>
  <div
    class="hover-hand border rounded p-4 w-full hover:shadow-lg transition-shadow duration-200 hover:border-course text-gray-900 dark:border-dark-400 dark:text-dark-text dark:bg-dark-500 dark:hover:border-course-dark"
    @click="onClick"
  >
    <div class="text-sm flex items-center">
      <div class="border rounded px-1 text-course border-course dark:text-course-dark dark:border-course-dark">
        {{ course.type }}
      </div>
      <div class="ml-3 text-gray-800 dark:text-dark-text">
        {{ course.shortName }}
      </div>
    </div>
    <div class="text-base font-bold mt-2 text-gray-800 dark:text-dark-text">
      {{ course.name }}
    </div>
    <div class="w-5/6 text-xs flex items-center text-gray-600 dark:text-dark-text">
      <span class="m-2">{{ calc2digit(course.progress) }}%</span>
      <base-progress-bar :num="calc2digit(course.progress)" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import BaseProgressBar from './BaseProgressBar.vue'

export default defineComponent({
  components: {
    BaseProgressBar
  },
  props: {
    course: {
      type: Object,
      required: true
    },
    onClick: {
      type: Function,
      required: true
    }
  },
  setup() {
    const calc2digit = (num: number) => Math.floor((num + 0.005) * 100) / 100

    return {
      calc2digit
    }
  }
})
</script>

<style lang="postcss" scoped>
.hover-hand {
  cursor: pointer;
  cursor: hand;
}
</style>
